import { useMutation } from '@tanstack/react-query'
import { UpdateQuestionBodyType } from '@/types/question.type'
import { axiosInstance } from '@/lib/axios'

interface UpdateProps {
  questionId: string
  data: UpdateQuestionBodyType
}

interface UpdateCaseProps {
  caseStudyId: number
  content: string
}

export const updateQuestion = async ({ questionId, data }: UpdateProps) => {
  return axiosInstance.patch(`/question/${questionId}`, data)
}

export const updateCaseStudy = async ({
  caseStudyId,
  content,
}: UpdateCaseProps) => {
  return axiosInstance.patch(`/case-study/${caseStudyId}`, { content })
}

export const useUpdateQuestion = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['updateQuestion'],
    mutationFn: updateQuestion,
  })

  return { updateQuestionAsync: mutateAsync, isUpdating: isPending }
}

export const useUpdateCaseStudy = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['updateCaseStudy'],
    mutationFn: updateCaseStudy,
  })

  return { updateCaseStudyAsync: mutateAsync, isUpdatingCaseStudy: isPending }
}
